/**
 * Privacy Policy Page
 *
 * Renders the privacy policy markdown content inside the reusable
 * LegalPage layout. Content is imported as a raw string so legal
 * text can be edited without touching React components.
 */

import { LegalPage } from '../components/shared/LegalPage';
import privacyContent from '../content/privacy-policy.md?raw';

export default function PrivacyPage() {
  return (
    <LegalPage
      title="Privacy Policy"
      lastUpdated="February 16, 2026"
      content={privacyContent}
      seoPath="/privacy"
      seoDescription="Learn how Haive collects, uses, and protects your personal data. GDPR-compliant privacy policy for TimelessHaven Unip. Lda."
    />
  );
}
